import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=2e93e27f&scoped=true"
import script from "./Recommendations.vue?vue&type=script&lang=js"
export * from "./Recommendations.vue?vue&type=script&lang=js"
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=2e93e27f&prod&lang=scss&scoped=true"
import style1 from "./Recommendations.vue?vue&type=style&index=1&id=2e93e27f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93e27f",
  null
  
)

export default component.exports